import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import { createBookmark, getBookmark } from './BookmarkApi';
import { removeClassFromLocalStorage } from '../../helper';

export interface IBookmark {
  tutorId: string;
  studentId: string;
  subject: string;
  subTopicId: string;
  subTopicName: string;
  pageNo: string;
  isMeetingEnded?: boolean;
}

export interface IClass {
  tutorId: string;
  studentId: string;
  subject: string;
  start: string;
  end: string;
  meetingId: string;
}

export interface IBookmarkState {
  status: 'idle' | 'loading' | 'rejected';
  bookmark: IBookmark;
}

const initialState: IBookmarkState = {
  status: 'idle',
  bookmark: {
    tutorId: '',
    studentId: '',
    subject: '',
    subTopicId: '',
    subTopicName: '',
    pageNo: '',
  },
};

export const BookmarkSlice = createSlice({
  name: 'bookmark',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Bookmark
      .addCase(createBookmark.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createBookmark.fulfilled, (state, action) => {
        state.status = 'idle';
        if (action?.payload?.isMeetingEnded) {
          removeClassFromLocalStorage();
        }
      })
      .addCase(createBookmark.rejected, (state) => {
        state.status = 'rejected';
      })

      // Get Bookmark
      .addCase(getBookmark.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getBookmark.fulfilled, (state, action) => {
        state.status = 'idle';
        state.bookmark = action.payload;
      })
      .addCase(getBookmark.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getBookmarkState = (state: RootState): RootState['bookmark'] =>
  state.bookmark;

export * from './BookmarkApi';
export default BookmarkSlice.reducer;
